module.exports = __webpack_public_path__ + "static/media/0_Fitness_Workout_3840x2160.105c2f3f.mp4";